window.addEventListener(
    'contextmenu',
    function (e) {
        e.preventDefault();
    },
    false
);